import React, { Component } from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import { t } from '@lingui/macro';
import {withI18n} from "@lingui/react";
import ActionAccess from '../../../components/Access/ActionAccess';
import { PermissionV2 } from '../../../components/Access/helper/permission/enum/PermissionV2';
import { DeleteOutlined } from '@ant-design/icons';
import { Styled } from './styled';
import { Checkbox } from '../../../components/DataEntry';
import {connect} from 'react-redux';

export const getDisplayName = (billingCP = {}) => {
    let computedName;
    if (billingCP.first_name)
        computedName = billingCP.first_name + (billingCP.last_name ? ` ${billingCP.last_name}` : '');
    else if (billingCP.last_name)
        computedName = billingCP.last_name;
    else
        computedName = '';

    return computedName;
};
class ContactFormGroup extends Component {
    onCheckboxChange = (name, value = []) => {
        const {
            contactPerson,
            setContactPerson,
        } = this.props;

        const updatedContactPerson = {
            ...contactPerson,
            is_default_billing: value.includes('is_default_billing'),
            is_default_shipping: value.includes('is_default_shipping'),
        };

        setContactPerson(updatedContactPerson.key, updatedContactPerson, true);
    };

    onDelete = () => {
        const {
            contactPerson,
            removeContactPerson,
        } = this.props;
        removeContactPerson(contactPerson.key);
    };

    getName = fieldName => {
        const { contactPerson } = this.props;
        return [`contact_person_${contactPerson.key}`, fieldName];
    };

    onNamesChange = (name, value) => {
        const {
            contactPerson,
            setContactPerson,
        } = this.props;

        const updatedContactPerson = {
            ...contactPerson,
            [name]: value || null,
        };

        setContactPerson(contactPerson.key, updatedContactPerson, false);
    };

    render() {
        const {
            disabled,
            isView,
            readOnly,
            gridSize,
            contactPerson,
        } = this.props;

        const isMobile = gridSize === "xs" || gridSize === "sm";

        return (
            <Styled>
                <Row wrap={isMobile} gutter={[16, 0]}>
                    <Col flex="auto">
                        {/* distance among input columns */}
                        <Row gutter={[8, 8]}>
                            <Col span={12}>
                                <Form.Item
                                    name={this.getName('first_name')}
                                    label={t`First Name`}
                                >
                                    <Input
                                        placeholder={contactPerson.idx % 2 === 0 ? t`Aisyah` : t`Wei Ling`}
                                        disabled={disabled}
                                        readOnly={readOnly}
                                        onChange={e => this.onNamesChange('first_name', e.target.value)}
                                        autoFocus={!contactPerson.id}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name={this.getName('last_name')} label={t`Last Name`}>
                                    <Input
                                        placeholder={contactPerson.idx % 2 === 0 ? t`binti Ismail` : t`Tan`}
                                        disabled={disabled}
                                        readOnly={readOnly}
                                        onChange={e => this.onNamesChange('last_name', e.target.value)}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} style={{display: "flex", justifyContent: "space-between", marginTop: isMobile ? "6px" : "0px"}}>
                                <Form.Item name={this.getName('default_settings')} style={{width: "100%"}}>
                                    <Checkbox.Group
                                        className={`${!isMobile && 'radio-button'}`}
                                        style={{ width: "100%", display: "grid", gridTemplateColumns: "1fr 1fr", gridColumnGap: isMobile ? "40px" : "8px" }}
                                        childrenStyle={{ marginTop: "auto", marginBottom: "auto", height: "fit-content" }}
                                        options={[
                                            {
                                                label: t`Default Billing`,
                                                value: 'is_default_billing',
                                            },
                                            {
                                                label: t`Default Shipping`,
                                                value: 'is_default_shipping',
                                            },
                                        ]}
                                        onChange={value => (
                                            !readOnly && this.onCheckboxChange('default_settings', value)
                                        )}
                                        readOnly={readOnly}
                                        disabled={disabled}
                                    />
                                </Form.Item>
                                {isMobile &&
                                    <ActionAccess
                                        requiredLevel={isView ? PermissionV2.update : PermissionV2.create}
                                    >
                                        <Button
                                            icon={<DeleteOutlined />}
                                            type="primary"
                                            danger
                                            onClick={() => this.onDelete()}
                                            className="delete-button"
                                            disabled={disabled}
                                        />
                                    </ActionAccess>}
                            </Col>
                        </Row>
                    </Col>
                    {!isMobile &&
                        <Col flex="none" style={{marginTop: "26px"}}>
                            <ActionAccess
                                requiredLevel={isView ? PermissionV2.update : PermissionV2.create}
                            >
                                <Button
                                    icon={<DeleteOutlined />}
                                    type="primary"
                                    danger
                                    onClick={() => this.onDelete()}
                                    className="delete-button"
                                    disabled={disabled}
                                />
                            </ActionAccess>
                        </Col>}
                </Row>
            </Styled>
        );
    }
}

export default connect(state => ({
    gridSize: state.App.gridSize,
}), {
})(withI18n()(ContactFormGroup));
